import { render } from "../templates/scenario-benefits-tree-actions.html?vue&type=template&id=99333b5a&scoped=true"
import script from "./scenario-benefits-tree-actions.vue?vue&type=script&lang=js"
export * from "./scenario-benefits-tree-actions.vue?vue&type=script&lang=js"

import "./scenario-benefits-tree-actions.vue?vue&type=style&index=0&id=99333b5a&lang=scss&scoped=true"

import exportComponent from "/var/www/lbr.ru/crm/vue_source/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-99333b5a"]])

export default __exports__